<template>
  <ion-app>
    <ion-content>
      <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
      <ion-grid>
        <div :class="notification.class">
          <ion-icon mode="ios" name="alert" class="mr-2 mt-0"></ion-icon>
          <p class="mb-0 mt-0">{{ notification.message }}</p>
        </div>
        <div class="back-button-bg" @click="gotoBack">
          <ion-icon mode="ios" name="arrow-back" size="large" class="white"></ion-icon>
        </div>
        <p class="page-title">Editar preferências</p>
      </ion-grid>
      <div class="edit-block-fixed mt-5">
        <label>De quais ingredientes você não gosta?</label>
        <ais-instant-search
          class="mt-3"
          :search-client="searchClient"
          index-name="IngredientsIndex"
        >
          <ais-search-box class="mb-3" ref="searchBox" />
          <ais-hits
            :class-names="{
              'ais-Hits-item': 'MyCustomHitsItem'
            }"
          >
            <div
              slot="item"
              slot-scope="{ item }"
              class="cursor-pointer search-hit"
              @click="selectIngredient(item)"
            >
              <p class="mt-0 mb-1 ion-text-uppercase grey text-sm">{{ item.category }}</p>
              <p class="mt-0 mb-0 bold text-lg">{{ item.namePT }}</p>
            </div>
          </ais-hits>
          <ais-configure :hits-per-page.camel="1" />
        </ais-instant-search>
        <div class="preference-list mt-4">
          <div v-for="preference in preferences" :key="preference.id" class="d-inline-block">
            <ion-chip>
              <ion-label>{{ preference.namePT }}</ion-label>
              <ion-icon
                mode="ios"
                name="close-circle"
                class="cursor-pointer"
                @click="removeIngredient(preference.id)"
              ></ion-icon>
            </ion-chip>
          </div>
        </div>
      </div>
      <div class="bottom-button-fixed">
        <ion-button shape="round" expand="block" mode="ios" @click="saveInfo">
          <ion-icon mode="ios" name="checkmark" class="white" size="large"></ion-icon>
        </ion-button>
      </div>
    </ion-content>
  </ion-app>
</template>

<script>
// algolia
import algoliasearch from "algoliasearch/lite";
import "instantsearch.css/themes/algolia-min.css";
// firebase
import db from "@/firebase/init";
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// store
import store from "../../utils/store.js";
// component
export default {
  name: "EditPreferences",
  components: {
    Loading
  },
  data() {
    return {
      notification: {
        class: "error-message p-3 d-none",
        message: null
      },
      isLoading: false,
      fullPage: true,
      user: store.state.user,
      profile: store.state.profile,
      preferences: [],
      searchClient: algoliasearch(
        "7SV0OCMMIQ",
        "7ffa9318b3c6b0d8b93fb27f11935ead"
      )
    };
  },
  methods: {
    clearNotification() {
      this.notification = {
        class: "error-message p-3 d-none",
        message: null
      };
    },
    startLoading() {
      const instance = this;
      instance.isLoading = true;
      setTimeout(() => {
        instance.loading = false;
      }, 3000);
    },
    gotoBack() {
      this.$router.go(-1);
    },
    selectIngredient(item) {
      const preferences = this.preferences;
      let idList = [];
      for (let i = 0; i < preferences.length; i++) {
        idList.push(preferences[i].id);
      }
      if (!idList.includes(item.objectID)) {
        const itemObj = {
          id: item.objectID,
          namePT: item.namePT
        };
        preferences.push(itemObj);
      }
      this.preferences = preferences;
    },
    removeIngredient(id) {
      const preferences = this.preferences;
      for (let i = 0; i < preferences.length; i++) {
        if (preferences[i].id === id) {
          preferences.splice(i, 1);
        }
      }
      this.preferences = preferences;
    },
    saveInfo() {
      const instance = this;
      instance.startLoading();
      const preferences = instance.preferences;
      const ref = db
        .collection("users")
        .where("userId", "==", instance.user.uid);
      ref.get().then(snapshot => {
        snapshot.forEach(doc => {
          db.collection("users")
            .doc(doc.id)
            .update({
              preferences: preferences
            })
            .then(() => {
              instance.profile.data.preferences = preferences;
              store.updateProfile(instance.profile);
              instance.isLoading = false;
              instance.$router.push({
                name: "Meal Plan"
              });
            })
            .catch(error => {
              instance.isLoading = false;
              instance.notification = {
                class: "error-message p-3",
                message:
                  "Ocorreu um erro ao processar essa operação. Tente novamente."
              };
              setTimeout(() => {
                instance.clearNotification();
              }, 3000);
            });
        });
      });
    }
  },
  async created() {
    const instance = this;
    await store.signinUser();
    instance.user = store.state.user;
    instance.profile = store.state.profile;
    try {
      if (instance.profile.data.preferences) {
        instance.preferences = instance.profile.data.preferences;
      }
    } catch (e) {
      console.log(e);
      instance.isLoading = false;
    }
  }
};
</script>

<style scoped>
ion-content {
  --background: linear-gradient(
    180deg,
    var(--ion-color-primary),
    white,
    white,
    white
  ) !important;
}
</style>
